import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/brand/brand-default.svg'


const _withScopeId = n => (_pushScopeId("data-v-41b9f518"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "p-ml-3" }, "search", -1))
const _hoisted_2 = { class: "p-input-icon-left p-grid p-col-3 p-ml-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search p-ml-2 p-pl-1" }, null, -1))
const _hoisted_4 = { class: "p-d-flex" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  src: _imports_0,
  class: "img-notif"
}
const _hoisted_7 = { class: "p-d-flex p-flex-column" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "date" }, "2 days ago", -1))
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("span", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_InputText, {
        class: "p-col-1",
        type: "text",
        modelValue: _ctx.searchInput,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchInput) = $event)),
        placeholder: "Search for Campaign, Contract or Client"
      }, null, 8, ["modelValue"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationsForUser, (not) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "p-col-12 p-d-flex p-justify-between p-mt-4 notifications-view",
        key: not
      }, [
        _createElementVNode("div", _hoisted_4, [
          (not?.brandId?.photo)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: not?.brandId?.photo,
                class: "img-notif"
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("img", _hoisted_6)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", null, [
              _createElementVNode("span", {
                innerHTML: not?.message
              }, null, 8, _hoisted_8)
            ]),
            _hoisted_9
          ])
        ]),
        _createElementVNode("div", {
          class: "p-mr-4 p-text-bold go-campaign",
          onClick: ($event: any) => (_ctx.notificationsMethods.methods[not?.type](not))
        }, "GO TO CAMPAIGN ", 8, _hoisted_10)
      ]))
    }), 128))
  ]))
}